import script from "./SidebarMenuBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarMenuBadge.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__